var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-main',{attrs:{"user-store":_vm.userStore,"account-store":_vm.accountStore}})}
var staticRenderFns = []

export { render, staticRenderFns }